<ng-container *ngIf="healthRecord?.Animal">
    <ng-template [ngTemplateOutlet]="labelValuePair"
                 [ngTemplateOutletContext]="{
                    label: 'Animal ID',
                    value: healthRecord.Animal.Material?.Identifier }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
                 [ngTemplateOutletContext]="{
                    label: 'Animal Name',
                    value: healthRecord.Animal.AnimalName }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
                 [ngTemplateOutletContext]="{
                    label: 'Location',
                    value: healthRecord.Animal.Material?.CurrentLocationPath }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
                 [ngTemplateOutletContext]="{
                    label: 'Line' | translate,
                    value: healthRecord.Animal.Material?.Line?.LineName }"></ng-template>
</ng-container>

<ng-template #labelValuePair let-label="label" let-value="value">
    <div class="form-group row" *ngIf="!useTableFormat">
        <label class="col-md-2 col-form-label">{{label}}</label>
        <div class="col-md-10">
            <p class="form-control-plaintext">
                {{value}}
            </p>
        </div>
    </div>

    <tr *ngIf="useTableFormat">
        <td>{{label}}</td>
        <td>{{value}}</td>
    </tr>
</ng-template>
